import type { CountryCode } from "libphonenumber-js";

import { Group, Input } from "@mantine/core";
import { usePhoneInput } from "react-international-phone";

import { CountrySelect } from "./CountrySelect/CountrySelect";
import classes from "./PhoneInput.module.css";

interface PhoneInputProps {
    value: string;
    onChange: (phone: string) => void;
    defaultCountry?: CountryCode;
    countrySelectEnabled?: boolean;
    clientEnabledCountries?: CountryCode[] | undefined;
}

export function PhoneInput({
    value,
    onChange,
    defaultCountry = "US",
    countrySelectEnabled = false,
    clientEnabledCountries,
}: PhoneInputProps) {
    const phoneInput = usePhoneInput({
        defaultCountry: defaultCountry.toLowerCase(),
        value,
        onChange: ({ phone }) => {
            onChange(phone);
        },
    });

    return (
        <Group className={classes.container}>
            {countrySelectEnabled && (
                <Group className={classes.autocompleteWrapper}>
                    <CountrySelect
                        setCountry={phoneInput.setCountry}
                        clientEnabledCountries={clientEnabledCountries}
                        defaultCountry={defaultCountry}
                    />
                </Group>
            )}
            <Input
                classNames={{ wrapper: classes.inputWrapper, input: classes.input }}
                onChange={phoneInput.handlePhoneValueChange}
                value={phoneInput.inputValue}
                styles={{
                    input: {
                        backgroundColor: "var(--mantine-color-dark-8)",
                    },
                }}
            />
        </Group>
    );
}
